import { render, staticRenderFns } from "./ComixCarousel.vue?vue&type=template&id=15123350&scoped=true&"
import script from "./ComixCarousel.vue?vue&type=script&lang=js&"
export * from "./ComixCarousel.vue?vue&type=script&lang=js&"
import style0 from "./ComixCarousel.vue?vue&type=style&index=0&id=15123350&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15123350",
  null
  
)

export default component.exports